import React from 'react';
import { Box, Typography, CircularProgress, Divider } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const LoadMoreButton = ({
  onClick,
  isLoading = false,
  disabled = false,
  label = 'Load More',
  loadingLabel = 'Loading...',
  sx = {},
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 1,
        ...sx,
      }}
    >
      {/* Left divider */}
      <Divider sx={{ flex: 1, mr: 2 }} />

      {/* Load more content */}
      <Box
        onClick={disabled || isLoading ? undefined : onClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: disabled || isLoading ? 'default' : 'pointer',
          px: 2,
          py: 1,
          borderRadius: '6px',
          transition: 'all 0.2s ease-in-out',
          opacity: disabled ? 0.5 : 1,
          '&:hover': {
            backgroundColor: disabled || isLoading ? 'transparent' : 'action.hover',
          },
        }}
      >
        {isLoading ? (
          <>
            <CircularProgress size={16} thickness={4} sx={{ color: 'primary.main' }} />
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontSize: '0.875rem',
                fontWeight: 500,
              }}
            >
              {loadingLabel}
            </Typography>
          </>
        ) : (
          <>
            <Typography
              variant="body2"
              sx={{
                color: 'primary.main',
                fontSize: '0.875rem',
                fontWeight: 600,
              }}
            >
              {label}
            </Typography>
            <KeyboardArrowDownIcon
              sx={{
                color: 'primary.main',
                fontSize: '1.25rem',
              }}
            />
          </>
        )}
      </Box>

      {/* Right divider */}
      <Divider sx={{ flex: 1, ml: 2 }} />
    </Box>
  );
};

export default LoadMoreButton;
